<template lang="pug">
v-dialog(v-model="dialog" width="600" persistent)
    template(v-slot:activator="{ on, attrs }")
        v-btn.ml-2(small color="primary" dark v-bind="attrs" v-on="on" outlined rounded)
            v-icon(left) mdi-pencil
            | Edit
    v-card(:loading="loading")
        v-card-title Update Custom survey for "{{ item.user.fname }} {{ item.user.lname }}"
        v-card-text
            //- center
            //-     v-avatar.mt-8(v-if="user.avatar" :size="45")
            //-         img(:src="user.avatar")
            //-     div(v-if="user.name") {{ user.name }}
            //-     select-user(:label="user.avatar ? 'Change User' : 'Select User'" @select="selectUser" :disabled="loading")
                

            feathers-vuex-find(service="bh-survey-options" :query="optionQuery" :fetch-query="optionFetchQuery" watch="query")
                template(slot-scope="{ items }")
                    v-combobox(
                        v-model="main_question"
                        :items="items"
                        label="Type or Select Main Question"
                        outlined
                        dense
                        item-text="title"
                        item-value="id"
                        :disabled="loading"
                    )

            feathers-vuex-find(service="bh-survey-options" :query="option2Query" :fetch-query="option2FetchQuery" watch="query")
                div(slot-scope="{ items }")

                    v-expansion-panels
                        v-expansion-panel
                            v-expansion-panel-header
                                b YES
                            v-expansion-panel-content
                                v-combobox(
                                    v-model="form.data.yes[0]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                                v-combobox(
                                    v-model="form.data.yes[1]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                                v-combobox(
                                    v-model="form.data.yes[2]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                                v-combobox(
                                    v-model="form.data.yes[3]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                                v-combobox(
                                    v-model="form.data.yes[4]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                        v-expansion-panel
                            v-expansion-panel-header
                                b NO
                            v-expansion-panel-content
                                v-combobox(
                                    v-model="form.data.no[0]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                                v-combobox(
                                    v-model="form.data.no[1]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                                v-combobox(
                                    v-model="form.data.no[2]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                                v-combobox(
                                    v-model="form.data.no[3]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                                v-combobox(
                                    v-model="form.data.no[4]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )
                
        v-snackbar(v-model="error.show" top color="red")
            v-icon(left) mdi-alert-circle-outline
            | {{ error.message }}
            template(v-slot:action="{ attrs }")
                v-btn(
                    color="white"
                    text
                    v-bind="attrs"
                    @click="error.show = false"
                ) Close

        v-divider
        v-card-actions
            v-spacer
            v-btn(v-if="!loading" small color="red" text @click="dialog = false") Cancel
            v-btn(small color="primary" text @click="submit" :loading="loading") Submit
            
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SelectUser from './SelectUser.vue';

export default {
    props: {
        item: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            // user: {
            //     avatar: null,
            //     name: null
            // },
            error: {
                show: false,
                message: null
            },
            main_question: null,
            form: {
                // user_id: null,
                data: {
                    yes: [null, null, null, null, null],
                    no: [null, null, null, null, null]
                }
            }
        };
    },
    computed: {
        optionQuery() {
            return { type: '"bool"' };
        },
        optionFetchQuery() {
            return { type: '"bool"', $paginate: 'false' };
        },
        option2Query() {
            return { type: { $ne: '"bool"' } };
        },
        option2FetchQuery() {
            return { type: { $ne: '"bool"' }, $paginate: 'false' };
        },
        ...mapGetters('bh-survey-options', { getOption: 'get' })
    },
    async mounted() {
        const tree = JSON.parse(this.item.survey_tree);
        let targetId = null;
        const treeData = Object.keys(tree).reduce((res, key) => {
            targetId = parseInt(key);
            res.yes = tree[key].yes;
            res.no = tree[key].no;
            return res;
        }, {});
        await this.getAllOptions({
            query: { $paginate: 'false' }
        });
        this.main_question = this.getOption(targetId);
        this.form.data.yes = treeData.yes.map(i => this.getOption(i));
        this.form.data.no = treeData.no.map(i => this.getOption(i));
    },
    methods: {
        selectUser(item) {
            this.form.user_id = item.id;
            this.user.avatar = item.profile_picture_thumb;
            this.user.name = item.artist_name;
        },
        async submit() {
            try {
                this.loading = true;
                if(this.form.data.yes.filter(i => !!i).length  === 0) throw new Error('Please fille some "YES" options.');
                if(this.form.data.no.filter(i => !!i).length  === 0) throw new Error('Please fille some "NO" options.');
                if(!this.main_question) throw new Error('Please select main question.');
                
                if(typeof this.main_question === 'string') {
                    const result = await this.createRole({
                        title: this.main_question,
                        type: '"bool"'
                    });
                    this.main_question = result;
                } else {
                    this.main_question = this.main_question;
                }

                const yesOptions = await Promise.all(this.form.data.yes.filter(i => !!i).map(async item => {
                    if(typeof item === 'string') {
                        const result = await this.createRole({
                            title: item,
                            option_description: '["Terrible", "Indifferent / Doesn’t stand out", "Just ok", "I like it", "Going to be a hit"]',
                            type: '{"type":"int", "data": [1,2,3,4,5]}'
                        });
                        return result.id;
                    }
                    return item.id;
                }));

                const noOptions = await Promise.all(this.form.data.no.filter(i => !!i).map(async item => {
                    if(typeof item === 'string') {
                        const result = await this.createRole({
                            title: item,
                            option_description: '["Terrible", "Indifferent / Doesn’t stand out", "Just ok", "I like it", "Going to be a hit"]',
                            type: '{"type":"int", "data": [1,2,3,4,5]}'
                        });
                        return result.id;
                    }
                    return item.id;
                }));

                const resultData = {
                    [this.main_question.id]: {
                        yes: yesOptions,
                        no: noOptions
                    }
                };

                // await this.createCustomSurvey({
                //     user_id: this.form.user_id,
                //     survey_tree: JSON.stringify(resultData)
                // });
                this.item.survey_tree = JSON.stringify(resultData);
                this.item.patch();

                this.$emit('success');

                this.dialog = false;
            } catch(err) {
                this.error.message = err.message;
                this.error.show = true;
            } finally {
                this.loading = false;
            }
        },
        itemCheck(item) {
            return typeof item !== 'object'
        },
        ...mapActions('bh-user-survey-custom', { createCustomSurvey: 'create' }),
        ...mapActions('bh-survey-options', { getAllOptions: 'find', createRole: 'create' })
    },
    components: {
        SelectUser
    },
}
</script>